import { TrashIcon } from '@heroicons/react/solid';
import { FormSelectInput } from '@wajeez-web/components/form-builder';
import { useCommonDispatch } from '@wajeez-web/stores/common';
import {
  Button,
  Card,
  Modal,
  SwitchInput,
  DeleteItemAlert,
} from '@wajeez-web/components/ui';
import { Content, Server } from '@wajeez-web/core/api-base';
import FormUploadInput from 'libs/components/form-builder/src/lib/Inputs/FormUploadInput';
import {
  useContentSelector,
  ContentEntityAudiosActions,
} from '@wajeez-web/stores/content';
import { IoSaveOutline } from 'react-icons/io5';
import {
  Control,
  FieldArrayWithId,
  useController,
  UseControllerProps,
  UseFieldArrayRemove,
  UseFormRegister,
  UseFormSetValue,
} from 'react-hook-form';

interface ContentEntityNarratorAudioProps {
  control: Control<Server.CreateContentEntityByTypeIdV2Input> | undefined;
  register: UseFormRegister<Server.CreateContentEntityByTypeIdV2Input>;
  index: number;
  removeNarratorAudio: UseFieldArrayRemove;
  narrators: Server.NarratorLookUpOutput[];
  // narratorAudios: FieldArrayWithId<
  //   Server.CreateContentEntityByTypeIdV2Input,
  //   'narratorAudios',
  //   'id'
  // >[];
  narratorAudios: Server.NarratorAudiosInput[];
  setValue: UseFormSetValue<Server.CreateContentEntityByTypeIdV2Input>;
  narratorSelectable: boolean;
  removeAllowed?: boolean;
  profileIndex: number;
}

const ContentEntityNarratorAudio = ({
  removeNarratorAudio,
  index,
  control,
  narrators,
  narratorAudios,
  setValue,
  narratorSelectable,
  register,
  removeAllowed,
  profileIndex,
}: ContentEntityNarratorAudioProps) => {
  const { field } = useController({
    control,
    name: `profiles.${profileIndex}.narratorAudios.${index}.isDefault`,
  });
  const dispatch = useCommonDispatch();

  const conponentForm = () => {
    return (
      <div className="">
        <div className="flex justify-end">
          {' '}
          {/* {contentId && (
      <Button
        loading={savingAudio}
        Icon={IoSaveOutline}
        color="primary"
        type="text"
        onClick={async () => {
          const response = audiosData[index]?.contentEntityAudioId
            ? await dispatch(
                ContentEntityAudiosActions.updateAudioAsync({
                  contentEntityAudioId:
                    audiosData[index].contentEntityAudioId,
                  audioReference:
                    control._formValues['narratorAudios'][index]
                      .audioReference,
                })
              )
            : await dispatch(
                ContentEntityAudiosActions.addAudioAsync({
                  languageId: 1,
                  contentEntityId: contentId,
                  audioReference:
                    control._formValues['narratorAudios'][index]
                      .audioReference,
                  isDefault:
                    control._formValues['narratorAudios'][index]
                      .isDefault,
                  narratorId:
                    control._formValues['narratorAudios'][index]
                      .narratorId,
                })
              );
          if (response.meta.requestStatus === 'fulfilled') {
            getAudios && getAudios(contentId || '');
          }
        }}
      />
    )} */}
          {Boolean(removeAllowed) && (
            <Button
              Icon={TrashIcon}
              color="red-500 "
              type="text"
              onClick={async () => {
                // TODO: This should remove the audio item from the list without any api call
                removeNarratorAudio(index);
                // // @ts-ignore
                // if (narratorAudios[index]?.contentEntityAudioId) {
                //   DeleteItemAlert(async () => {
                //     const response = await dispatch(
                //       ContentEntityAudiosActions.removeAudioAsync({
                //         contentEntityAudioId:
                //           // @ts-ignore
                //           narratorAudios[index].contentEntityAudioId,
                //       })
                //     );
                //     if (response.meta.requestStatus === 'fulfilled') {
                //       getAudios && getAudios(contentId || '');
                //       // removeNarratorAudio(index);
                //       if (
                //         narratorAudios.length > 0 &&
                //         narratorAudios.every((s) => !s.isDefault)
                //       ) {
                //         setValue(
                //           `profiles.${profileIndex}.narratorAudios.${index}.isDefault`,
                //           true
                //         );
                //       }
                //     }
                //   });
                // } else removeNarratorAudio(index);
              }}
            />
          )}
        </div>
        <div className={`grid grid-cols-${1} gap-3 `}>
          {narratorSelectable && (
            <div className={`md:col-span-${4} col-span-${4}`}>
              <FormSelectInput
                {...register(
                  `profiles.${profileIndex}.narratorAudios.${index}.narratorId`
                )}
                control={control}
                name={`profiles.${profileIndex}.narratorAudios.${index}.narratorId`}
                fieldType={{
                  fieldType: Server.FieldType.Select,
                  label: 'Narrator',

                  placeHolder: 'Select Narrator',
                  fieldOptions: {
                    selectOptions: narrators.map((n) => ({
                      label: n.name ?? '',
                      value: n.id ?? '',
                    })),
                  },
                }}
              />
            </div>
          )}
          <div className={`md:col-span-${4} col-span-${4}`}>
            <FormUploadInput
              {...register(
                `profiles.${profileIndex}.narratorAudios.${index}.audioReference`
              )}
              control={control}
              name={`profiles.${profileIndex}.narratorAudios.${index}.audioReference`}
              fieldType={{
                fieldType: Server.FieldType.UploadFile,
                label: 'Audio',
                required: false,
                placeHolder: 'Upload Audio',
                fieldOptions: {
                  types: ['audio/mpeg', 'audio/mp3', 'audio/wav', 'audio/ogg'],
                },
              }}
            />
          </div>
          <div className={`md:col-span-${4} col-span-${4}`}>
            {/* <FormSwitchInput
        control={control}
        name={`profiles.${profileIndex}.narratorAudios.${index}.isDefault`}
        fieldType={{
          label: 'is Default',
          placeHolder: 'Make This audio as default',
          fieldType: Server.FieldType.Switch,
        }}
      /> */}
            {narratorSelectable && (
              <SwitchInput
                {...register(
                  `profiles.${profileIndex}.narratorAudios.${index}.isDefault`
                )}
                value={field.value}
                label="is Default"
                required={false}
                placeholder="Make This audio as default"
                name="isDefault"
                onChange={(name, value) => {
                  for (let i = 0; i < narratorAudios.length; i++) {
                    if (i != index) {
                      setValue(
                        `profiles.${profileIndex}.narratorAudios.${i}.isDefault`,
                        false
                      );
                    }
                  }
                  field.onChange(true);
                }}
              />
            )}
          </div>
        </div>{' '}
      </div>
    );
  };
  return narratorSelectable ? (
    <Card key={`${index}`}>{conponentForm()}</Card>
  ) : (
    conponentForm()
  );
};

export default ContentEntityNarratorAudio;
